export default __webpack_public_path__ + "static/media/Eye_6_F_C2.b2cfa8b3.svg";